const postpaidLinesStyle = (theme) => ({
	radioButtons: {
		display: 'inline-flex',
		width: '100%',
		[theme.breakpoints.down('sm')]: {
			display: 'flex',
			width: '100%',
			marginLeft: 15,
		},
	},
	servicePicker: {
		width: '100%',
	},
	servicePickerWrapper: {
		[theme.breakpoints.down('sm')]: {
			overflow: 'auto',
		},
	},
	text: {
		marginTop: 8,
		fontWeight: 'bold',
	},
	commitmentPicker: {
		marginLeft: '6%',
	},
});

export default postpaidLinesStyle;
